import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from "../../../../../context/AuthContext";
import Swal from "sweetalert2";

export const AdminPackageandPrice = () => {
    const { user } = useAuth();
    const { t } = useTranslation();

    const [msg, setMsg] = useState("");
    const [courses, setCourses] = useState([]);
    const [loadingCourses, setLoadingCourses] = useState(true);
    const [form, setForm] = useState({
        packageName: "",
        packageDetail: "",
        packagePrice: "",
        studentLimit: "",
        howManyDays: "",
        courseId: "",
        isItPrivate: "",
        isInvidual: ""
    });

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const headers = {
                    accept: "*/*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "false",
                    Authorization: "Bearer " + user.token
                };

                const url = "https://api.heryerdeingilizce.com/api/admin/CourseManager/GetCourses";

                const res = await axios({
                    method: "GET",
                    url,
                    headers
                });

                if (res.status === 200 && res.data?.success) {
                    const activeCourses = (res.data.data || []).filter(
                        (course) => course.isDeleted === false && course.isActive === true
                    );
                    setCourses(activeCourses);
                } else {
                    setMsg(res.data?.message || "Kurslar alınamadı.");
                }
            } catch (err) {
                setMsg(err?.message || "Kurslar alınamadı.");
            } finally {
                setLoadingCourses(false);
            }
        };

        fetchCourses();
    }, [user.token]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const headers = {
                accept: "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                Authorization: "Bearer " + user.token
            };

            const url = "https://api.heryerdeingilizce.com/api/admin/Package/Create";

            const res = await axios({
                method: "POST",
                url,
                data: {
                    packageName: form.packageName,
                    packageDetail: form.packageDetail,
                    packagePrice: Number(form.packagePrice),
                    studentLimit: Number(form.studentLimit),
                    howManyDays: Number(form.howManyDays),
                    sortNumber: Number(form.courseId),
                    isItPrivate: form.isItPrivate === "true",
                    isInvidual: form.isInvidual === "true",
                    isActive: true
                },
                headers
            });

            if (res.status === 200 && res.data?.success) {
                await Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                window.location.reload();
                return;
            }

            Swal.fire({
                title: "Hata!",
                icon: "error",
                confirmButtonText: "Tamam"
            });
            setMsg(res.data?.message || "Beklenmedik bir hata oluştu.");
        } catch (err) {
            setMsg(err?.message || "Beklenmedik bir hata oluştu.");
        }
    };

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-9 col-xl-8">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">{t("packagesAndPrices")}</h1>
                                <p className="text-muted mb-0">{t("createPackage")}</p>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="packageName" className="form-label">
                                        {t("packageName")}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="packageName"
                                        value={form.packageName}
                                        onChange={handleChange}
                                        required
                                        rows={2}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="packageDetail" className="form-label">
                                        {t("packageDescription")}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="packageDetail"
                                        value={form.packageDetail}
                                        onChange={handleChange}
                                        required
                                        rows={3}
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="packagePrice" className="form-label">
                                            {t("packagePrice")}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="packagePrice"
                                            value={form.packagePrice}
                                            onChange={handleChange}
                                            required
                                        />
                                        <small className="text-muted">{t("useNumbers")}</small>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="studentLimit" className="form-label">
                                            {t("studentLimit")} <i>Bireysel Paketlerde 1 seçilsin.</i>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="studentLimit"
                                            value={form.studentLimit}
                                            onChange={handleChange}
                                            required
                                        />
                                        <small className="text-muted">{t("useNumbers")}</small>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="howManyDays" className="form-label">
                                            {t("validityDate")}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="howManyDays"
                                            value={form.howManyDays}
                                            onChange={handleChange}
                                            required
                                        />
                                        <small className="text-muted">
                                            {t("useNumbers")} {t("daily")}
                                        </small>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="courseId" className="form-label">
                                            Kurs Seçiniz
                                        </label>
                                        <select
                                            id="courseId"
                                            className="form-select"
                                            value={form.courseId}
                                            onChange={handleChange}
                                            required
                                            disabled={loadingCourses}
                                        >
                                            <option value="">
                                                {loadingCourses ? "Kurslar yükleniyor..." : t("select")}
                                            </option>
                                            {courses.map((course) => (
                                                <option key={course.id} value={course.id}>
                                                    {course.courseName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="isInvidual" className="form-label">
                                            {t("isInvidual")}
                                        </label>
                                        <select
                                            id="isInvidual"
                                            className="form-select"
                                            value={form.isInvidual}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">{t("select")}</option>
                                            <option value="true">{t("yes")}</option>
                                            <option value="false">{t("no")}</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="isItPrivate" className="form-label">
                                            Gizli Paket mi?
                                        </label>
                                        <select
                                            id="isItPrivate"
                                            className="form-select"
                                            value={form.isItPrivate}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">{t("select")}</option>
                                            <option value="true">{t("yes")}</option>
                                            <option value="false">{t("no")}</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="d-grid d-md-flex justify-content-md-center mt-4">
                                    <button type="submit" className="btn btn-primary btn-lg px-4">
                                        {t("create")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPackageandPrice;